import { render, staticRenderFns } from "./TooltipUnimed.vue?vue&type=template&id=18523b6a"
import script from "./TooltipUnimed.vue?vue&type=script&lang=js"
export * from "./TooltipUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports